import {FormsList, EntriesList, EntryDetails} from "./Tabs/paypalEntriesTab";

export default function App() {
  const params = new URLSearchParams(window.location.search);

  const formId = params.get("cfywpay_formid");
  const entryId = params.get("cfywpay_entryid");

  if (formId && entryId) {
    return <EntryDetails formId={formId} entryId={entryId} />;
  }

  if (formId) {
    return <EntriesList formId={formId} />;
  }

  return <FormsList />;
}